// this is an auto generated file. This will be overwritten

export const createDanceStyle = /* GraphQL */ `
  mutation CreateDanceStyle(
    $condition: ModelDanceStyleConditionInput
    $input: CreateDanceStyleInput!
  ) {
    createDanceStyle(condition: $condition, input: $input) {
      beatsPerBar
      createdAt
      discipline
      id
      name
      patterns {
        nextToken
        __typename
      }
      routines {
        nextToken
        __typename
      }
      status
      updatedAt
      __typename
    }
  }
`;
export const createPattern = /* GraphQL */ `
  mutation CreatePattern(
    $condition: ModelPatternConditionInput
    $input: CreatePatternInput!
  ) {
    createPattern(condition: $condition, input: $input) {
      createdAt
      danceStyle {
        beatsPerBar
        createdAt
        discipline
        id
        name
        status
        updatedAt
        __typename
      }
      danceStylePatternsId
      id
      name
      order
      status
      updatedAt
      variations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createRoutine = /* GraphQL */ `
  mutation CreateRoutine(
    $condition: ModelRoutineConditionInput
    $input: CreateRoutineInput!
  ) {
    createRoutine(condition: $condition, input: $input) {
      createdAt
      danceStyleRoutinesId
      id
      name
      owner
      patternList
      status
      updatedAt
      videos
      __typename
    }
  }
`;
export const createVariation = /* GraphQL */ `
  mutation CreateVariation(
    $condition: ModelVariationConditionInput
    $input: CreateVariationInput!
  ) {
    createVariation(condition: $condition, input: $input) {
      beats
      createdAt
      hold
      id
      level
      order
      pattern {
        createdAt
        danceStylePatternsId
        id
        name
        order
        status
        updatedAt
        __typename
      }
      patternVariationsId
      rhytm
      rhytmMan
      status
      updatedAt
      videos {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createVideo = /* GraphQL */ `
  mutation CreateVideo(
    $condition: ModelVideoConditionInput
    $input: CreateVideoInput!
  ) {
    createVideo(condition: $condition, input: $input) {
      createdAt
      id
      order
      status
      updatedAt
      url
      variation {
        beats
        createdAt
        hold
        id
        level
        order
        patternVariationsId
        rhytm
        rhytmMan
        status
        updatedAt
        __typename
      }
      variationVideosId
      __typename
    }
  }
`;
export const deleteDanceStyle = /* GraphQL */ `
  mutation DeleteDanceStyle(
    $condition: ModelDanceStyleConditionInput
    $input: DeleteDanceStyleInput!
  ) {
    deleteDanceStyle(condition: $condition, input: $input) {
      beatsPerBar
      createdAt
      discipline
      id
      name
      patterns {
        nextToken
        __typename
      }
      routines {
        nextToken
        __typename
      }
      status
      updatedAt
      __typename
    }
  }
`;
export const deletePattern = /* GraphQL */ `
  mutation DeletePattern(
    $condition: ModelPatternConditionInput
    $input: DeletePatternInput!
  ) {
    deletePattern(condition: $condition, input: $input) {
      createdAt
      danceStyle {
        beatsPerBar
        createdAt
        discipline
        id
        name
        status
        updatedAt
        __typename
      }
      danceStylePatternsId
      id
      name
      order
      status
      updatedAt
      variations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteRoutine = /* GraphQL */ `
  mutation DeleteRoutine(
    $condition: ModelRoutineConditionInput
    $input: DeleteRoutineInput!
  ) {
    deleteRoutine(condition: $condition, input: $input) {
      createdAt
      danceStyle {
        beatsPerBar
        createdAt
        discipline
        id
        name
        status
        updatedAt
        __typename
      }
      danceStyleRoutinesId
      id
      name
      owner
      patternList
      status
      updatedAt
      videos
      __typename
    }
  }
`;
export const deleteVariation = /* GraphQL */ `
  mutation DeleteVariation(
    $condition: ModelVariationConditionInput
    $input: DeleteVariationInput!
  ) {
    deleteVariation(condition: $condition, input: $input) {
      beats
      createdAt
      hold
      id
      level
      order
      pattern {
        createdAt
        danceStylePatternsId
        id
        name
        order
        status
        updatedAt
        __typename
      }
      patternVariationsId
      rhytm
      rhytmMan
      status
      updatedAt
      videos {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteVideo = /* GraphQL */ `
  mutation DeleteVideo(
    $condition: ModelVideoConditionInput
    $input: DeleteVideoInput!
  ) {
    deleteVideo(condition: $condition, input: $input) {
      createdAt
      id
      order
      status
      updatedAt
      url
      variation {
        beats
        createdAt
        hold
        id
        level
        order
        patternVariationsId
        rhytm
        rhytmMan
        status
        updatedAt
        __typename
      }
      variationVideosId
      __typename
    }
  }
`;
export const updateDanceStyle = /* GraphQL */ `
  mutation UpdateDanceStyle(
    $condition: ModelDanceStyleConditionInput
    $input: UpdateDanceStyleInput!
  ) {
    updateDanceStyle(condition: $condition, input: $input) {
      beatsPerBar
      createdAt
      discipline
      id
      name
      patterns {
        nextToken
        __typename
      }
      routines {
        nextToken
        __typename
      }
      status
      updatedAt
      __typename
    }
  }
`;
export const updatePattern = /* GraphQL */ `
  mutation UpdatePattern(
    $condition: ModelPatternConditionInput
    $input: UpdatePatternInput!
  ) {
    updatePattern(condition: $condition, input: $input) {
      createdAt
      danceStyle {
        beatsPerBar
        createdAt
        discipline
        id
        name
        status
        updatedAt
        __typename
      }
      danceStylePatternsId
      id
      name
      order
      status
      updatedAt
      variations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateRoutine = /* GraphQL */ `
  mutation UpdateRoutine(
    $condition: ModelRoutineConditionInput
    $input: UpdateRoutineInput!
  ) {
    updateRoutine(condition: $condition, input: $input) {
      createdAt
      danceStyleRoutinesId
      id
      name
      owner
      patternList
      status
      updatedAt
      videos
      __typename
    }
  }
`;
export const updateVariation = /* GraphQL */ `
  mutation UpdateVariation(
    $condition: ModelVariationConditionInput
    $input: UpdateVariationInput!
  ) {
    updateVariation(condition: $condition, input: $input) {
      beats
      createdAt
      hold
      id
      level
      order
      pattern {
        createdAt
        danceStylePatternsId
        id
        name
        order
        status
        updatedAt
        __typename
      }
      patternVariationsId
      rhytm
      rhytmMan
      status
      updatedAt
      videos {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateVideo = /* GraphQL */ `
  mutation UpdateVideo(
    $condition: ModelVideoConditionInput
    $input: UpdateVideoInput!
  ) {
    updateVideo(condition: $condition, input: $input) {
      createdAt
      id
      order
      status
      updatedAt
      url
      variation {
        beats
        createdAt
        hold
        id
        level
        order
        patternVariationsId
        rhytm
        rhytmMan
        status
        updatedAt
        __typename
      }
      variationVideosId
      __typename
    }
  }
`;
